import { apiFetch } from "./api";
import { getLastRequestId } from "./api-log";

// After the VX iframe reports PASS / FAIL / CLOSE, fetch the result the way a
// customer's server would, purely so the "Under the hood" panel shows the
// retrieval. Page state is driven by the postMessage, not by this call.
// If VX still reports the journey as pending, poll every 3 s for up to 30 s.

const POLL_MS = 3000;
const MAX_MS = 30000;

// VX status values: PASS, FAIL and ERROR are terminal; PENDING is the only
// in-flight value. No status at all is treated as pending as a fallback.
function isPending(data) {
  const inner = data && typeof data === "object" && "body" in data ? data.body : data;
  const st = String(inner?.status ?? "").toUpperCase();
  return !st || st === "PENDING";
}

const sleep = (ms) => new Promise((r) => setTimeout(r, ms));

export async function runStatusCheck(demo, requestId = getLastRequestId()) {
  if (!requestId) return;
  const started = Date.now();
  let attempt = 0;
  // Only label attempts once we know we are polling.
  for (;;) {
    attempt += 1;
    let data;
    try {
      data = await apiFetch("/demo/vx/get-result.php", { request_id: requestId, demo }, { attempt: attempt > 1 ? attempt : undefined });
    } catch (e) {
      return; // the panel already shows the failed call
    }
    if (!isPending(data) || Date.now() - started + POLL_MS > MAX_MS) return;
    await sleep(POLL_MS);
  }
}
